const SET_FETCHING = 'directOrderRecurring/SET_FETCHING';
const SET_SUBMITTING = 'directOrderRecurring/SET_SUBMITTING';

export default {
  SET_FETCHING,
  SET_SUBMITTING,
};
